import React from 'react';
import { Chip, alpha, useTheme } from '@mui/material';

export default function BundleChip() {
    const theme = useTheme();

    return (
        <Chip
            label="BUNDLE"
            size="medium"
            sx={{
                fontSize: '12px',
                fontWeight: 700,
                lineHeight: '266%',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                height: '24px',
                backgroundColor: alpha(theme.palette.info.main, 0.12),
                color: theme.palette.info.main,
            }}
        />
    );
}
